{
  "welcome": "欢迎来到",
  "instructions": "点击下方按钮开始签到流程。",
  "startCheckIn": "开始签到",
  "missingWarehouseTitle": "缺少仓库信息",
  "missingWarehouseMessage": "该链接无效，链接中必须包含仓库 ID",
  "recaptchaAttribution": "本网站受 reCAPTCHA 保护，Google 的{privacyPolicy}和{termsOfService}适用。",
  "recaptchaPrivacyPolicy": "隐私政策",
  "recaptchaTermsOfService": "服务条款",
  "lookupTitle": "添加参考号或确认号以查找您的预约",
  "referenceNumberLabel": "参考号或确认号",
  "referenceNotFoundError": "该参考号或确认号与任何有效预约都不匹配。",
  "checkIn": "签到",
  "loadTypeLabel": "货物类型",
  "directionLabel": "方向",
  "operationLabel": "操作",
  "dockLabel": "站台",
  "orDivider": "或",
  "noReferenceTitle": "我没有确认号",
  "noReferenceDescription": "使用标准签到流程，在没有预约的情况下继续。",
  "checkInWithoutAppointment": "无预约签到",
  "readyToCheckInTitle": "准备好签到了吗？",
  "readyToCheckInDescription": "点击下方开始。您将在下一个屏幕输入您的信息。",
  "referenceRequiredHint": "在此地点签到需要提供参考号。",
  "haveAppointment": "我有预约",
  "direction": {
    "inbound": "入库",
    "outbound": "出库",
    "inOut": "入库与出库",
    "load": "装货",
    "unload": "卸货"
  },
  "operation": {
    "live": "现场装卸",
    "drop": "甩挂",
    "other": "其他"
  }
}
